import React from 'react';
import './ActionButtons.scss';

export interface ActionButtonsProps {
  showButtons?: {
    view?: boolean;
    start?: boolean;
    procedureLock?: boolean;
    flowModelLock?: boolean;
    edit?: boolean;
    copy?: boolean;
    tags?: boolean;
    delete?: boolean;
  };
  onViewClick?: () => void;
  onStartClick?: () => void;
  onProcedureLockClick?: () => void;
  onFlowModelLockClick?: () => void;
  onEditClick?: () => void;
  onCopyClick?: () => void;
  onTagsClick?: () => void;
  onDeleteClick?: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  showButtons: showButtons = {},
  onViewClick,
  onStartClick,
  onProcedureLockClick,
  onFlowModelLockClick,
  onEditClick,
  onCopyClick,
  onTagsClick,
  onDeleteClick
}) => {
  return (
    <div className="action-buttons-container">
      {(onViewClick || showButtons.view) && (
        <button
          type="button"
          className="action-button view-button"
          onClick={onViewClick}
          disabled={!onViewClick}
          title="View process map"
        >
          <i className="fa-light fa-eye"></i>
        </button>
      )}

      {(onStartClick || showButtons.start) && (
        <button
          type="button"
          className="action-button start-button"
          onClick={onStartClick}
          disabled={!onStartClick}
          title="Start flow"
        >
          <i className="fa-light fa-play"></i>
        </button>
      )}

      {(onProcedureLockClick || showButtons.procedureLock) && (
        <button
          type="button"
          className="action-button lock-button"
          onClick={onProcedureLockClick}
          disabled={!onProcedureLockClick}
          title="Edit sharing"
        >
          <i className="fa-light fa-lock-keyhole"></i>
        </button>
      )}

      {(onFlowModelLockClick || showButtons.flowModelLock) && (
        <button
          type="button"
          className="action-button lock-button"
          onClick={onFlowModelLockClick}
          disabled={!onFlowModelLockClick}
          title="Edit sharing, Flow Model Owners, and Report Owners"
        >
          <i className="fa-light fa-lock-keyhole"></i>
        </button>
      )}

      {(onEditClick || showButtons.edit) && (
        <button
          type="button"
          className="action-button edit-button"
          onClick={onEditClick}
          disabled={!onEditClick}
          title="Edit"
        >
          <i className="fa-light fa-pencil"></i>
        </button>
      )}

      {(onCopyClick || showButtons.copy) && (
        <button
          type="button"
          className="action-button copy-button"
          onClick={onCopyClick}
          disabled={!onCopyClick}
          title="Copy"
        >
          <i className="fa-light fa-copy"></i>
        </button>
      )}

      {(onTagsClick || showButtons.tags) && (
        <button
          type="button"
          className="action-button tags-button"
          onClick={onTagsClick}
          disabled={!onTagsClick}
          title="View Tags"
        >
          <i className="fa-light fa-tag"></i>
        </button>
      )}

      {(onDeleteClick || showButtons.delete) && (
        <button
          type="button"
          className="action-button delete-button"
          onClick={onDeleteClick}
          disabled={!onDeleteClick}
          title="Delete"
        >
          <i className="fa-light fa-trash-can"></i>
        </button>
      )}
    </div>
  );
};

export default ActionButtons;
